import {Search} from "./Search";
import {handleArrowNavigation, handleMouseNavigation, deselectOptions} from "./Navigation";
import {fromString} from "../../../ToastMessage";
import {initializeTemplateFields} from "../../TemplateFields";

const initializeSelector = (event) => {
    const button = event.target.closest('button.add-automation');

    if (!button) {
        return;
    }

    const selector = button.parentNode.querySelector('.automation-action-selector');

    const searchField = selector.querySelector('[name="query"]');

    const search = Search(selector);

    const closeButton = selector.querySelector('[data-selector-close]');

    const showButton = () => {
        button.style.display   = 'block';
        selector.style.display = 'none';

        searchField.removeEventListener('keyup', handleKeyboardInput);
        document.removeEventListener('mousemove', handleMouseInput);
        document.removeEventListener('click', closeHandler);
        document.removeEventListener('keyup', closeHandler);

        searchField.removeEventListener('keydown', selectionHandler);
        selector.removeEventListener('click', selectionHandler);
    };

    const showSelector = () => {
        button.style.display   = 'none';
        selector.style.display = 'block';

        selector.querySelector('ul').scrollTop = 0;

        const scrollContainer = button.closest('.side-panel')?.querySelector('.content');

        if (scrollContainer) {
            scrollContainer.scrollTop = scrollContainer.scrollHeight;
        }

        deselectOptions(selector);

        searchField.value = '';

        search.search(searchField.value);

        searchField.focus();
    };

    showSelector();

    const handleKeyboardInput = (event) => {
        handleArrowNavigation(selector, event);

        search.search(searchField.value);
    };

    const handleMouseInput = (event) => {
        deselectOptions(selector);

        handleMouseNavigation(selector, event);
    };

    const closeHandler = (event) => {
        if (!(event.type === 'click' && !selector.contains(event.target))
            && !(event.type === 'click' && closeButton.contains(event.target))
            && !(event.type === 'keyup' && event.key === 'Escape')
        ) {
            return;
        }

        showButton();
    };

    const selectionHandler = async (event) => {
        if (!(event.type === 'click' && event.target.closest('li')) && !(event.type === 'keydown' && event.key === 'Enter')) {
            return;
        }

        event.preventDefault();

        const selectedOption = selector.querySelector('li.selected');

        if (!selectedOption) {
            return;
        }

        const target = selector.closest('form').querySelector('[name="targetEntity"]').value;
        const addButton = selector.closest('.section').querySelector('.add-automation');

        const url = new URL(selectedOption.dataset.url, window.location.origin);

        url.searchParams.set('target', target);

        if (selectedOption.dataset.integrationStub) {
            url.searchParams.set('integrationStub', selectedOption.dataset.integrationStub);
        }

        const actionSection = addButton.parentNode;

        actionSection.classList.add('loading');

        try {
            const response = await fetch(url.toString());
            const stringContent = await response.text();

            if (response.status === 400) {
                fromString(stringContent);

                return;
            }

            const parsed = document.createElement('template');
            parsed.innerHTML = stringContent;

            addButton.parentNode.insertBefore(parsed.content, addButton);

            initializeTemplateFields(addButton.parentNode);

            document.querySelector('.side-panel').dispatchEvent(new CustomEvent('automationactionadded', {
                detail: {
                    action: document.querySelector('.side-panel :nth-last-child(1 of .automation-action)'),
                },
            }));

            showButton();
        } finally {
            actionSection.classList.remove('loading');
        }
    };

    searchField.addEventListener('keyup', handleKeyboardInput);
    document.addEventListener('mousemove', handleMouseInput);
    document.addEventListener('click', closeHandler);
    document.addEventListener('keyup', closeHandler);

    searchField.addEventListener('keydown', selectionHandler);
    selector.addEventListener('click', selectionHandler);
};

document.addEventListener('click', initializeSelector);
